import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { Button, Typography, useViewport } from '@chilecompra/react-kit/components'

import { Row } from './SelectOfferDialog.styles'

/**
 * The SelectOfferDialogFooter's component.
 */
const SelectOfferDialogFooter = props => {
  const { disabledPurchaseOrder, isOfferLowerPrice, loading, offerCounter, onClose, onSubmit } = props

  const {
    size: { isDownToTiny }
  } = useViewport()

  const textFooterDialog = useMemo(() => {
    if (offerCounter > 1) {
      return 'Las órdenes de compra se emitirán y quedarán en estado guardada. Podrás enviarlas desde el menú Orden de Compra de tu escritorio.'
    }
  }, [offerCounter])

  const buttonWidth = isDownToTiny ? '90%' : '337px'

  return (
    <>
      <Row margin="10px 0 0">
        <Typography align="center" color="black1" fontSize="12px" lineHeight="16px" margin="10px 0" variant="body2">
          {textFooterDialog}
        </Typography>
      </Row>
      <Row margin="10px 0 22px">
        <Button
          color="success"
          disabled={(!isOfferLowerPrice && disabledPurchaseOrder) || loading}
          loading={loading}
          onClick={onSubmit}
          type="button"
          width={buttonWidth}
        >
          Emitir orden de compra
        </Button>
      </Row>
      {!isOfferLowerPrice && (
        <Row margin="10px 0 0">
          <Button onClick={onClose} type="button" variant="outlined" width={buttonWidth}>
            Volver y seleccionar otro proveedor
          </Button>
        </Row>
      )}
    </>
  )
}

SelectOfferDialogFooter.propTypes = {
  offerCounter: PropTypes.number.isRequired,
  disabledPurchaseOrder: PropTypes.bool,
  isOfferLowerPrice: PropTypes.bool,
  loading: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func
}

export default SelectOfferDialogFooter
